<template>

<div v-if="hasRole(roles.RW_IMOB_CADASTROS) || hasRole(roles.RW_REAL_ESTA_ADMIN)">
  <div v-if="!flDetails" class="row">

  <div class="col-md-3">
     <Searchaccredited v-on:updateTableAccredited="updateTableAccredited"  v-on:SearchItems="GetFilter"></Searchaccredited>
  </div>

  <div class="col-md-7">
     <Tableaccredited ref="TableaccreditedComponent" :key="keyTableAccredited" v-on:deleteAccredited="deleteAccredited"  v-on:edit="edit"></Tableaccredited>
  </div>

     <Newaccredited v-on:updateTableAccredited="updateTableAccredited"></Newaccredited>

  </div>
  <div v-if="flDetails">
     <div class="row">
        <div class="col-md-3 ">
         <Abstractaccredited :key="keyAbstractaccredited" :edit="dataDetails"></Abstractaccredited>
        </div>
        <div class="col-md-9">
          <Painelaccredited  v-on:updateAbstractaccredited="updateAbstractaccredited" :dataedit="dataDetails" v-on:updateView="updateView"></Painelaccredited>
        </div>
     </div>
  </div>

</div>

</template>

<script>
import Accredited from '@/views/private/realestate/accredited/accredited'
export default Accredited
</script>

<style scoped>

.adjustment-painel{
   margin-right: 15%;
}

.table-ajuste{
  margin-right: 30%;
  margin-left: 2%;
}

 @media screen and (max-width: 1600px) {

.table-ajuste{
  margin-right: 5%;
  margin-left: 5%;
}

}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/accredited/accredited.vue